<div
  class="dropdown-overlay"
  *ngIf="panelVisible && selectedProperty && !isInternal"
  (click)="togglePanel(); $event.stopPropagation()"
></div>
<div class="property-banner-wrapper" *ngIf="selectedProperty && !isInternal">
  <div class="property-banner">
    <div class="property-banner-content">
      <div
        class="property-info"
        (click)="
          userProperties.length > 1 ? togglePanel() : null;
          $event.stopPropagation()
        "
      >
        <i class="fa-solid fa-location-dot property-icon"></i>
        <span class="community-name">{{ selectedProperty.communityName }}</span>
        <i
          *ngIf="userProperties.length > 1"
          class="fa-solid mobile-chevron"
          [ngClass]="{
            'fa-chevron-up': panelVisible,
            'fa-chevron-down': !panelVisible
          }"
        ></i>
        <span class="property-details">
          <span class="property-address">
            {{ selectedProperty.propertyAddress }}
          </span>
          <span class="account-id">({{ selectedProperty.customerId }})</span>
        </span>
      </div>
      <div
        class="property-switch"
        *ngIf="userProperties.length > 1"
        (click)="togglePanel(); $event.stopPropagation()"
      >
        <span>Switch Property</span>
        <i
          class="fa-solid"
          [ngClass]="{
            'fa-chevron-up': panelVisible,
            'fa-chevron-down': !panelVisible
          }"
        ></i>
      </div>
    </div>
  </div>

  <div
    class="switch-panel"
    *ngIf="panelVisible && userProperties.length > 1"
    (click)="$event.stopPropagation()"
  >
    <div class="switch-panel-container">
      <div class="switch-panel-header">
        <div class="switch-panel-title">
          <h2>Switch Property</h2>
          <p>
            Easily switch and manage multiple properties within our resident
            portal.
          </p>
        </div>
        <span
          class="close-link"
          (click)="togglePanel(); $event.stopPropagation()"
        >
          Close
          <i class="fa-solid fa-chevron-up"></i>
        </span>
      </div>

      <div class="search-container">
        <dx-text-box
          [(value)]="searchText"
          placeholder="Search property by name or address"
          [showClearButton]="true"
          valueChangeEvent="input"
          (onValueChanged)="onSearchChanged($event)"
        >
          <dxi-button
            name="search"
            location="before"
            [options]="{ icon: 'search', stylingMode: 'text' }"
          ></dxi-button>
        </dx-text-box>
      </div>

      <div class="property-list">
        <div *ngIf="isLoadingProperties" class="property-list-loading">
          <dx-load-indicator
            [visible]="true"
            height="40"
            width="40"
          ></dx-load-indicator>
        </div>
        <ng-container *ngIf="!isLoadingProperties">
          <div
            *ngFor="
              let property of filteredProperties;
              trackBy: trackByUniqueId
            "
            class="property-item"
            [ngClass]="{
              selected: property.uniqueId === selectedProperty?.uniqueId
            }"
            (click)="selectProperty(property); $event.stopPropagation()"
          >
            <div
              class="property-item-check"
              [ngClass]="{
                visible: property.uniqueId === selectedProperty?.uniqueId
              }"
            >
              <i class="fa-solid fa-circle-check"></i>
            </div>
            <div class="property-item-content">
              <div class="property-item-community">
                {{ property.communityName }}
              </div>
              <div class="property-item-address">
                {{ property.propertyAddress }}
              </div>
              <div class="property-item-id">{{ property.customerId }}</div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
